module.exports = __webpack_public_path__ + "img/cooperate2.580f4e06.png";